import { CheckCircle2 } from 'lucide-react';

export default function VerificationBadges({ profile }) {
  const labels = [profile?.email_verified === true && 'Email verified', profile?.phone_verified === true && 'Phone verified'].filter(Boolean);
  if (!labels.length) return null;
  return <div className="tt-verification" aria-label="Verified contact details">{labels.map(label => <span key={label}><CheckCircle2 size={14} aria-hidden="true" />{label}</span>)}</div>;
}
